var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"12","justify-self":"center"}},[_c('error-page',{attrs:{"description":_vm.$i18n.t('errors.page.403.title'),"error":"403"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }